const baseUrl = process.env.VUE_APP_BASEURL

export default {
  baseUrl,
  env: process.env.VUE_APP_ENV,
  sentry: process.env.VUE_APP_SENTRY,
  sentryRelease: process.env.VUE_APP_GIT_COMMIT,
  domain: process.env.VUE_APP_DOMAIN,
  awsUrl: process.env.VUE_APP_AWSRURL,
  rtcUrl: process.env.VUE_APP_BASERTCURL,
  audienceUrl: process.env.VUE_APP_AUDIENCERURL,
  presenterUrl: process.env.VUE_APP_PRESENTERURL,
  baseUrlSocket: process.env.VUE_APP_BASEURLSOCKET,
  isSentryEnabled: process.env.VUE_APP_IS_SENTRY_ENABLED === 'true',
  api: {
    checkPresentation: `${baseUrl}/api/presentation/check/`,
    getPresentation: `${baseUrl}/api/presentation/audience/`,
    getPresentationFromCdn: `${baseUrl}/api/presentation/audience-data/`,
    createAnswer: `${baseUrl}/api/answer/create/`,
    createOpenEndedOption: `${baseUrl}/api/slide-option/audience-create/`,
    createWordCloud: `${baseUrl}/api/slide-option/audience-create-wordcloud/`,
    currentOrderVoice: `${baseUrl}/api/answer/voice-number/`,
    reaction: `${baseUrl}/api/slide/reaction/`,
    createActionWebrtc: `${baseUrl}/api/webrtc/`,
    listSlide: `${baseUrl}/api/presentation/audience-presentation-slide-list/`,
    quizResult: `${baseUrl}/api/answer/quiz-result/`,
    slideQuizResult: `${baseUrl}/api/slide/quiz-result/`,
    joinPresentation: `${baseUrl}/api/presentation/join-presentation/`,
    createLeaderboard: `${baseUrl}/api/slide/audience-create-leaderboard/`,
    getTimestamp: `${baseUrl}/api/quiz/get-time-stamp/`,
    getNextSlide: `${baseUrl}/api/presentation/next-slide/`,
    createQuestion: `${baseUrl}/api/question/create/`,
    listQuestion: `${baseUrl}/api/question/list/`,
    voteQuestion: `${baseUrl}/api/question/vote/`,
    checkQuizTeamMember: `${baseUrl}/api/quiz/check-team-data/`,
    leaveQuizTeam: `${baseUrl}/api/quiz/leave-team/`,
  },
  roles: ['master', 'admin', 'presenter', 'audience'],
}
